<form [formGroup]="form" [waiting]="loadingService.isLoading$(this) | async" class="h-full">
  <div class="col-16 grow h-full">
    <icz-file-selector [form]="form" controlName="fileId" [additionalFilterCriteria]="additionalFilterCriteria" [excludeObjectsWithId]="[dialogFileData.id]" (objectsSelected)="onFileSelected($event)"></icz-file-selector>
    @if (prepareValidationError) {
      <span class="main-text-color validation-text">{{ prepareValidationError | translate }}</span>
    } @else {
      @if (isFileSelected && isSCRPrepareLoaded) {
        @if (isEntityClassConflict) {
          <icz-alert severity="warning" heading="Připojením spisů dochází ke konfliktu jejich skartačních režimů."></icz-alert>
          <icz-entity-class-selector controlName="conflictEntityClassId" label="Věcná skupina, do které budou zatříděny propojené spisy" [form]="form" [usage]="EntityClassSelectorUsage.ADMIN_HISTORIC_WITH_V" (valueChange)="conflictEntityClassChange($event)"></icz-entity-class-selector>
          <div class="row-24">
            <div class="col grow">
              <icz-form-autocomplete [options]="disposalOperationCodeOptions"
                                     formControlName="disposalOperationCode" label="Výsledný skartační znak"></icz-form-autocomplete>
              <icz-form-field formControlName="disposalYear" label="Předpokládaný rok vyřazení"></icz-form-field>
            </div>
            <div class="col grow">
              @if (disposalScheduleSourceEntitySelectedId) {
                <icz-retention-trigger-type-widget
                  [form]="form"
                  [externalRetentionTriggerIds]="externalRetentionTriggerIds"
                  [disposalScheduleId]="disposalScheduleSourceEntitySelectedId"
                  [retentionTriggerWidgetMode]="retentionTriggerValidationMode"
                  [showExternalRetentionYear]="true"
                ></icz-retention-trigger-type-widget>
              }
            </div>
          </div>
          <ng-container [ngTemplateOutlet]="filesForStrongCrossReferenceTemplate"></ng-container>
        } @else {
          @if (!sameEntityClass) {
            <icz-alert severity="info" [heading]="noConflictAlertText()"></icz-alert>
          }
          <div class="row">
            <ng-container [ngTemplateOutlet]="filesForStrongCrossReferenceTemplate"></ng-container>
            <div class="grow">
              <icz-entity-class-selector class="grow" controlName="entityClassId" label="Věcná skupina, do které budou zatříděny propojené spisy" [form]="form" [fieldDisabled]="true" [usage]="EntityClassSelectorUsage.OFFICER_HISTORIC_WITH_V"></icz-entity-class-selector>
              <icz-form-autocomplete label="Skartační režim" formControlName="disposalScheduleId" [options]="disposalSchedulesOptions$ | async" [fieldDisabled]="true"></icz-form-autocomplete>
            </div>
          </div>
        }
      }
    }
  </div>
</form>

<ng-template #filesForStrongCrossReferenceTemplate>
  <div class="grow">
    <icz-label label="Spisy, které propojujete pevnou vazbou:" class="font-bold"></icz-label>
    @for (file of filesForStrongCrossReference; track file.id) {
      <div class="row mt-8">
        <icz-object-class-icon [objectClass]="file.objectClass" iconSize="default" class="mt-4 block"></icz-object-class-icon>
        <icz-tag [label]="'en.fileState.' + file.fileState" [color]="getObjectTagColor($any(file))"></icz-tag>
        <icz-label [label]="file.refNumber + ' ' + file.subject" [hasNormalWhitespace]="true"></icz-label>
      </div>
    }
  </div>
</ng-template>

<icz-form-buttons>
  <icz-button leftButtons iczFormSubmit
              [disabled]="loadingService.isLoading(this)"
              (onAction)="submit()"
              primary label="Přidat pevnou vazbu na spis"
  ></icz-button>
  <icz-button rightButtons
              [disabled]="loadingService.isLoading(this)"
              (onAction)="cancel()" label="Storno"
  ></icz-button>
</icz-form-buttons>
